import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
dayjs.extend(isBetween);

export function filterDatesWithinRange(dates, startDate, endDate) {
  if (!Array.isArray(dates) || dates.length === 0) {
    return [];
  }

  const start = startDate ? dayjs(startDate, 'YYYY-MM-DD') : null;
  const end = endDate ? dayjs(endDate, 'YYYY-MM-DD') : null;

  if (!start || !end) {
    return [];
  }

  return dates.filter(date => {
    if (!date) return false;

    try {
      const dayjsDate = dayjs(date, 'YYYY-MM-DD');

      if (!dayjsDate.isValid()) return false;

      return dayjsDate.isBetween(start, end, 'day', '[]');
    } catch (error) {
      return false;
    }
  });
}

export function sortByDateAsc(dataArray) {
  return dataArray.sort((a, b) => {
    // Convert dates to dayjs objects using the correct 'YYYYMMDD' format
    const dateA = dayjs(a, 'YYYY-MM-DD');
    const dateB = dayjs(b, 'YYYY-MM-DD');
    // Sort from furthest to most recent
    return dateA.isAfter(dateB) ? 1 : -1;
  });
};

export function sortResultByDateAsc(array) {
  return array.sort((a, b) => {
    // Convertir las dates de formato 'DD/MM/YYYY' a objetos Date
    const dateA = new Date(a.date.split('/').reverse().join('-'));
    const dateB = new Date(b.date.split('/').reverse().join('-'));
    return dateA - dateB; // Restar para obtener el orden correcto
  });
};

//Function to check if a date is in the disabled dates list.
export const disabledDate = (enabledDates, current) => {
  return !enabledDates.includes(current.format('YYYY-MM-DD'));
};

// Función para deshabilitar dates en el DatePicker de la date de inicio
export function disabledStartDates(current, endDate) {
  // Si hay una date de fin seleccionada, deshabilita todas las dates posteriores
  return endDate ? current && current.isAfter(endDate, 'day') : false;
};

// Función para deshabilitar dates en el DatePicker de la date de fin
export function disabledEndDates(current, startDate) {
  // Si hay una date de inicio seleccionada, deshabilita todas las dates anteriores
  return startDate ? current && current.isBefore(startDate, 'day') : false;
};

function Date_correct(input_date, format) {
  if (format === 1) {
    if (input_date.length === 1) {
      input_date = "0" + input_date;
    }
  } else {
    if (input_date.length === 2 && input_date.charAt(0) === '0') {
      input_date = input_date[1];
    }
  }
  return input_date;
}

export function getDateAsStringArray(date) {
  const dateObject = dayjs(date)
  let selectedYear = (dateObject && (dateObject.$y !== null)) ? dateObject.$y.toString() : null;
  let selectedMonth = (dateObject && (dateObject.$M !== null)) ? Date_correct((dateObject.$M + 1).toString(), 1) : null;
  let selectedDay = (dateObject && (dateObject.$D !== null)) ? Date_correct(dateObject.$D.toString(), 1) : null;
  return { selectedDay, selectedMonth, selectedYear };
}

export function extractDate(str) {
  // Expresión regular para encontrar un patrón de fecha AAAA_MM_DD
  const datePattern = /(\d{4})_(\d{2})_(\d{2})/;
  const match = str.match(datePattern);

  // Si encuentra una coincidencia, devuelve la fecha en el formato AAAA-MM-DD
  if (match) {
    const [, year, month, day] = match;
    return dayjs(`${year}-${month}-${day}`);
  }
  // Si no se encuentra una fecha en el formato esperado, devuelve null
  return null;
}
